import { ReactNode } from 'react'
import { cn } from '../lib/cn'

interface LabeledRowProps {
  label: string
  children: ReactNode
  className?: string
}

/**
 * Fila rótulo/valor con el rótulo en negrita mayúscula a la izquierda, en una
 * columna de ancho fijo para que los valores queden alineados entre filas.
 *
 * Distinto de `KeyValueList`, que arma una grilla de pares para lectura en
 * pantalla: esto replica el formato de formulario impreso.
 */
export const LabeledRow = ({ label, children, className }: LabeledRowProps) => (
  <div className={cn('flex gap-3 break-inside-avoid', className)}>
    <span className='w-[32mm] shrink-0 font-bold uppercase'>{label}:</span>
    <span className='min-w-0 flex-1'>{children}</span>
  </div>
)
